module.exports = __webpack_public_path__ + "static/media/placeholder-blurred.55de9a4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DevicePreview/placeholder-blurred.png
// module id = 1508
// module chunks = 0